/**
 * Unregisters any service workers left behind by the old CRA build.
 * The app never registers its own service worker.
 */
export function unregister(): void {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker
      .getRegistrations()
      .then(registrations => registrations.forEach(r => r.unregister()))
      .catch(() => undefined);
  }
}
